var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "code-check" },
    [
      _c("div", { staticClass: "clearfix" }),
      _vm._m(0),
      _c("div", { staticClass: "row" }, [
        _vm._m(1),
        _c(
          "div",
          { staticClass: "col-12 col-sm-6" },
          [_c("login", { attrs: { loginType: "codecheck" } })],
          1
        ),
      ]),
      _vm._m(2),
      _c("div", { staticClass: "row" }, [
        _vm._m(3),
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c("p", { staticClass: "d-none d-sm-block" }, [
            _vm._v("Promóció kód ellenőrzése"),
          ]),
          _c(
            "form",
            {
              attrs: {
                method: "post",
                action: "api/ajax-validate-code.php",
                id: "validate_code",
              },
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.code.$model,
                      expression: "$v.code.$model",
                    },
                  ],
                  class: {
                    "form-control": true,
                    "form-input-item": true,
                    "invalid-error": _vm.$v.code.$error,
                  },
                  attrs: { type: "text" },
                  domProps: { value: _vm.$v.code.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.$v.code, "$model", $event.target.value)
                    },
                  },
                }),
              ]),
              _c(
                "button",
                {
                  staticClass: "button button-sm",
                  attrs: { type: "button" },
                  on: { click: _vm.codeSubmit },
                },
                [_vm._v("Ellenőrzés")]
              ),
            ]
          ),
        ]),
      ]),
      _vm._m(4),
      _c("simplemodal", {
        attrs: {
          modal_title: _vm.modalData.title,
          modal_content: _vm.modalData.content,
          modal_id: _vm.modalData.key,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("p", [_vm._v("Kedves Játékos!")]),
        _c("p", [
          _vm._v(
            " Köszönjük, hogy a Baumit hőszigetelő rendszereit választva részt vett promóciónkban,"
          ),
          _c("br"),
          _vm._v(
            " Kétféleképpen tudja leellenőrizni, hogy promóciónk során nyert-e vagy sem: "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-6" }, [
      _c("ol", [
        _c("li", [
          _vm._v(
            "Lépjen be a regisztrációkor megadott e-mail címével és a kapott jelszavával itt:"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row pt-4 pb-4" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("p", { staticClass: "text-center" }, [_vm._v("Vagy")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-6" }, [
      _c("ol", { attrs: { start: "2" } }, [
        _c("li", [
          _vm._v("Használja a regisztrációkor megadott kódját és írja be ide:"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row pt-5" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("p", [
          _vm._v(
            "A nyertesekkel a Baumit munkatársai személyesen veszik fel a kapcsolatot a megadott elérhetőségeiken keresztül."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }